/** Static content for /travel-trends — avoids empty hub when API has no guides. */

export const TRENDS_HUB = {
	title: 'Trending in Nepal',
	lead: 'Beyond Everest and Pokhara — digital nomads, community treks, wellness travel, and photography circuits that more visitors are choosing each year.',
	sections: [
		{
			id: 'digital-nomad',
			question: 'Digital nomad and long-stay travel',
			answer: 'Kathmandu (Thamel, Patan) and Pokhara Lakeside have a growing coworking and cafe scene with reliable wifi. Nepal has no dedicated digital-nomad visa — remote workers use standard tourist visas with stay limits. Plan connectivity carefully outside the two main cities; teahouse wifi on trek is slow and paid.',
		},
		{
			id: 'community-treks',
			question: 'Community and eco treks',
			answer: 'Routes like Mohare Danda, Khopra Ridge, and Tamang Heritage Trail use community-run lodges where revenue stays in villages. These are alternatives to crowded classics like Poon Hill — slightly less infrastructure but more authentic homestay culture and fewer trekkers on the trail.',
		},
		{
			id: 'wellness',
			question: 'Wellness and yoga retreats',
			answer: 'Pokhara and the Kathmandu Valley host yoga retreats, meditation courses, and Ayurveda programs — especially in quieter months (monsoon and winter). These are usually booked directly with centers rather than through trek agencies. Combine a short retreat with a low-altitude cultural trip if you are not trekking.',
		},
		{
			id: 'photography',
			question: 'Photography-focused travel',
			answer: 'Golden-hour locations include Nagarkot and Bhaktapur for valley sunrises, Phewa Lake dawn in Pokhara, Boudhanath at butter-lamp dusk, and Kala Patthar on the EBC trek. Festival photography (Indra Jatra, Holi, Tihar) requires planning around lunar calendar dates. Respect temple rules — ask before photographing people and ceremonies.',
		},
		{
			id: 'rain-shadow',
			question: 'Monsoon-season alternatives',
			answer: 'Upper Mustang and Manang sit in the Himalayan rain shadow — treks there work when classic routes are muddy and cloud-covered. Chitwan and Bardia jungle safaris also run through monsoon with afternoon rain patterns. Smart shoulder-season travel is a growing trend among repeat Nepal visitors.',
		},
	],
	faqs: [
		{
			q: 'Is Nepal good for solo travelers in 2026?',
			a: 'Yes — solo trekking and city travel are common. Group departures exist specifically for solo travelers who want company on the trail. Tourist Police (1144) operate in major areas. Standard safety awareness applies in cities at night.',
		},
		{
			q: 'What is replacing overcrowded treks?',
			a: 'Mardi Himal, Khopra Ridge, Pikey Peak, and Langtang see growing interest as alternatives to EBC and ABC peak crowds. Restricted areas (Upper Mustang, Manaslu) limit numbers by permit design.',
		},
	],
};
